<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.UrlCodec.title') }}</span>
      <el-tooltip :content="$t('tool.UrlCodec.componentTip')" placement="bottom">
        <span :class="['uc-chip',{on:encodeMode==='component'}]" @click="encodeMode='component'">{{ $t('tool.UrlCodec.componentMode') }}</span>
      </el-tooltip>
      <el-tooltip :content="$t('tool.UrlCodec.fullTip')" placement="bottom">
        <span :class="['uc-chip',{on:encodeMode==='full'}]" @click="encodeMode='full'">{{ $t('tool.UrlCodec.fullMode') }}</span>
      </el-tooltip>
      <span class="fmt-spacer"/>
      <el-button size="small" icon="el-icon-sort" @click="encode">{{ $t('common.action.encode') }}</el-button>
      <el-button size="small" @click="decode">{{ $t('common.action.decode') }}</el-button>
      <el-button size="small" plain icon="el-icon-star-off" @click="loadSample">{{ $t('common.action.sample') }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doCopy">{{ $t('common.action.copy') }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t('common.action.clear') }}</el-button>
    </div>
    <el-input v-model="text" type="textarea" :rows="12"
      :placeholder="focused ? $t('tool.UrlCodec.phPasted') : $t('tool.UrlCodec.phInput')"
      class="fmt-textarea" @input="onInput" @focus="focused=true" @blur="focused=false"/>
    <div class="fmt-status-bar">
      <span v-if="errorMsg" class="fmt-err"><i class="el-icon-warning"/> {{ errorMsg }}</span>
      <span v-else-if="lastOp" class="fmt-ok"><i class="el-icon-circle-check"/> {{ lastOp }}</span>
      <span v-else-if="text.trim()" class="fmt-hint">{{ detectHint || $t('common.hint.charCount', { n: charCount }) }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.UrlCodec.hintEmpty') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:'UrlCodecTool',props:{config:{type:Object,default:()=>({})}},
  data:function(){
    return { text:'', encodeMode:'full', errorMsg:'', lastOp:'', detectHint:'', focused:false,
      sample: this.$t('tool.UrlCodec.sample') }
  },
  computed:{
    charCount:function(){ return this.text.length }
  },
  methods:{
    onInput:function(){
      this.errorMsg = ''; this.lastOp = ''; this.detectHint = ''
      if (this.text.trim()) {
        var hasEncoded = /%[0-9A-Fa-f]{2}/.test(this.text)
        this.detectHint = hasEncoded ? this.$t('tool.UrlCodec.detectEncoded') : this.$t('tool.UrlCodec.detectPlain')
      }
    },
    encode:function(){
      this.errorMsg = ''; this.lastOp = ''; this.detectHint = ''
      if (!this.text.trim()) return
      try {
        this.text = this.encodeMode === 'component' ? encodeURI(this.text) : encodeURIComponent(this.text)
        this.lastOp = this.$t('tool.UrlCodec.msgEncoded', { n: this.text.length })
      } catch(e) { this.errorMsg = this.$t('tool.UrlCodec.msgEncodeFail', { msg: e.message }) }
    },
    decode:function(){
      this.errorMsg = ''; this.lastOp = ''; this.detectHint = ''
      if (!this.text.trim()) return
      try {
        var s = this.text.replace(/\+/g, ' ')
        this.text = decodeURIComponent(s)
        this.lastOp = this.$t('tool.UrlCodec.msgDecoded', { n: this.text.length })
      } catch(e) {
        this.errorMsg = this.$t('tool.UrlCodec.msgDecodeFail')
      }
    },
    doCopy:function(){
      if (!this.text.trim()) { this.$message.warning(this.$t('common.status.noContent')); return }
      navigator.clipboard.writeText(this.text).then(() => this.$message.success(this.$t('common.status.copied')))
    },
    loadSample:function(){ this.text = this.$t('tool.UrlCodec.sample'); this.errorMsg = ''; this.lastOp = ''; this.detectHint = '' },
    clearAll:function(){ this.text = ''; this.errorMsg = ''; this.lastOp = ''; this.detectHint = '' },
    doAction:function(a){
      if (a === 'copy') this.doCopy()
      if (a === 'clear') this.clearAll()
    }
  }
}
</script>

<style scoped>
.fmt-tool { display: flex; flex-direction: column; gap: 12px; }

.fmt-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.fmt-toolbar >>> .el-button + .el-button { margin-left: 0; }
.fmt-label { font-size: 13px; font-weight: 700; color: #1a1f36; }
.fmt-spacer { flex: 1; }

.uc-chip { padding: 5px 14px; border-radius: 6px; font-size: 12px; font-weight: 600; cursor: pointer; color: #909399; background: #f0f2f5; transition: .12s; border: 1px solid transparent; }
.uc-chip:hover { color: #4e7cff; }
.uc-chip.on { background: #e8f0fe; color: #4e7cff; border-color: #4e7cff; }

.fmt-textarea >>> textarea {
  font-family: 'JetBrains Mono','Fira Code','Consolas',monospace !important;
  font-size: 13px !important; line-height: 1.6 !important;
  border-radius: 10px; resize: vertical; min-height: 240px;
}

.fmt-status-bar { font-size: 12px; }
.fmt-err { color: #f56c6c; display: flex; align-items: center; gap: 4px; }
.fmt-ok { color: #67c23a; display: flex; align-items: center; gap: 4px; }
.fmt-hint { color: #c0c4cc; }
</style>
